import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import './TeamDetail.css'
import male from '../../images/male.png'
import female from '../../images/female.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter, faYoutube, faFoursquare } from '@fortawesome/free-brands-svg-icons'
import { faLink, faFlag, faMarsStroke, faFutbol } from '@fortawesome/free-solid-svg-icons'


const TeamDetail = () => {
    let { idTeam } = useParams();
    const [teamDetails, setTeamDetails] = useState([]);

    useEffect(() => {
        let url = `https://www.thesportsdb.com/api/v1/json/1/lookupteam.php?id=${idTeam}`;
        fetch(url)
            .then(res => res.json())
            .then(data => setTeamDetails(data.teams[0]))
    }, [idTeam])
    const { strTeam, strStadiumThumb, intFormedYear, strCountry, strSport, strGender, strTeamBadge, strDescriptionEN, strTwitter, strWebsite, strYoutube } = teamDetails;
    return (
        <main>
            <div style={{ backgroundImage: `url(${strStadiumThumb})` }} className="banner-img">
                <img className='img-fluid' src={strTeamBadge} alt="" />
            </div>
            <div className="container">
                <div className="details-wrapper">
                    <div className="row">
                        <div className="col-md-8">
                            <div className="left-box col">
                                <h1>{strTeam}</h1>
                                <h4><FontAwesomeIcon icon={faFoursquare} /> Founded In: {intFormedYear}</h4>
                                <h4><FontAwesomeIcon icon={faFlag} /> Country: {strCountry}</h4>
                                <h4><FontAwesomeIcon icon={faFutbol} /> Sport Type: {strSport}</h4>
                                <h4><FontAwesomeIcon icon={faMarsStroke} /> Gender: {strGender}</h4>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="right-img">
                                {
                                    strGender === 'Male' ? <img className="img-fluid" src={male} alt="Male Player" />
                                        : <img className="img-fluid" src={female} alt="Female Player" />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className='club-history'>
                    <p>{strDescriptionEN}</p>
                </div>
                <div className="social-icons">
                    <a target="_blank" rel='noreferrer' className='icons' href={`https://${strTwitter}`}> <FontAwesomeIcon icon={faTwitter} /></a>
                    <a target="_blank" rel='noreferrer' className='icons' href={`https://${strWebsite}`}> <FontAwesomeIcon icon={faLink} /></a>
                    <a target="_blank" rel='noreferrer' className='icons' href={`https://${strYoutube}`}> <FontAwesomeIcon icon={faYoutube} /></a>
                </div>
            </div>
        </main>
    );
};

export default TeamDetail;